export { SearchInput as default } from './SearchInput';
